import React, {
    Fragment,
    useCallback,
    useEffect,
    useRef,
    useState,
} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Badge,
    Box,
    Button,
    Grid,
    IconButton,
    List,
    ListItem,
    Typography,
} from '@material-ui/core';

import {
    member as v_member,
    basic,
    Values,
    member,
    material,
    SNACKBAR_TIME,
} from '../request/values';
import { COLORS } from './Theme';
import { useHistory } from 'react-router-dom';
import TitleBar from './header/TitleBar';
import NumberFormat from 'react-number-format';
import axios from 'axios';
import DialogConfirm from './Dialog';
import clsx from 'clsx';
import { useSnackbar } from 'notistack';
import { maxWidth } from '@material-ui/system';

const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
    titleIcon: {
        width: '5vw',
        height: 'auto',
    },
    list: {
        padding: '1vw',
        width: '100%',
        height: '80vh',
        overflowY: 'auto',
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        fontSize: '4vw',
        //alignContent: 'center',
        [theme.breakpoints.up('md')]: {
            width: '100%',
            height: '100%',
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(8),
        },
    },
    drawerOpenList: {
        height: '50vh',
    },

    materialItem: {
        // borderRadius: 12,
        border: `solid 1px ${COLORS.VERY_LIGHT_PINK}`,
        marginBottom: '1.5vh',
        padding: 0,
        borderRadius: '5px',
    },
    materialImage: {
        textAlign: 'center',
        margin: 'auto',
        '& img': {
            width: '14vw',
            maxWidth: '70px',
        },
    },
    icon: {
        width: '5vw',
    },
    materialDesc: {
        '& #materialName': {
            ...theme.typography.subtitle2,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
        },
        '& #materialSubName': {
            ...theme.typography.body1,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            color: `${COLORS.BROWNISH_GREY}`,
        },
    },
    materialButtonSection: {
        '& #price': {
            margin: 'auto',
            textAlign: 'center',
            ...theme.typography.subtitle2,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            alignItems: 'center',
        },
        '& #count': {
            margin: 'auto',
            textAlign: 'center',
            ...theme.typography.subtitle2,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            alignItems: 'center',
        },
    },

    materialBottomBar: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        display: 'block',
        width: '100%',
        height: '11vh',
        // marginLeft: '-2.5vw',
        backgroundColor: `${COLORS.LIGHT_GREY}`,

        '& #saleButton': {
            borderRadius: '10px',
            boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
            backgroundColor: `${COLORS.WHITE}`,
            color: `${COLORS.WATER_BLUE}`,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            fontSize: '5vw',
        },
        '& .MaterialBottomicon': {
            width: '7.4vw',
        },
    },
    drawerOpenBomttomBar: {
        height: '32vh',
    },

    basketItem: {
        display: 'flex',
        width: '91vw',
        height: '6.5vh',
        alignItems: 'center',

        padding: '1vh 4vw',
        fontFamily: 'NanumB',
        fontWeight: 'bold',

        borderRadius: '12px',
        border: 'solid 1px #e4e4e4',
        backgroundColor: `${COLORS.WHITE}`,
        // "& img": {
        //     width: '9vw',
        // }
        '& #imageSection': {
            width: '20%',
        },
        '& #imageSection img': {
            width: '50%',
        },

        '& #nameSection': {
            width: '48%',
            color: `${COLORS.CHARCOAL_GREY}`,
        },

        '& #descSection': {
            textAlign: 'right',
            width: '18%',
            fontSize: '3vw',
        },
    },

    button: {
        width: '18vw',
        height: 'auto',
        borderRadius: '5px',
        backgroundColor: `${COLORS.WATER_BLUE}`,
        color: `${COLORS.LIGHT_GREY}`,
        padding: '1vw',
        fontSize: '2vw',
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        marginLeft: '1vw',
    },
    empty: {
        height: '62vh',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& img': {
            width: '35vw',
            height: '35vw',
            [theme.breakpoints.up('md')]: {
                width: '25vw',
                height: '25vw',
            },
            marginBottom: '2.5vh',
        },
        '& h1': {
            color: `${COLORS.DOWN}`,
        },
    },
    fixedButtonWrapper: {
        position: 'fixed',
        bottom: '20px',
        left: 0,
        right: 0,
        display: 'block',
        width: '100%',
        padding: '0 20px',
        [theme.breakpoints.up('md')]: {
            width: 'calc(100% - 290px)',
            left: '290px',
        },
    },
    materialLoanButton: {
        width: '100%',
        borderRadius: '1.8vw',
        backgroundColor: `${COLORS.WATER_BLUE}`,
    },
    materialLoanButtonText: {
        color: `${COLORS.WHITE}`,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
    },
}));

interface iMaterialList {
    materialCode: number;
    materialName: string;
    materialSubName: string;
    materialImage: string;
    materialPrice: number;
    quantity: number;
}

const MaterialList: React.FC<any> = (props) => {
    const classes = useStyles();
    const { member } = props;
    const history = useHistory();

    const [material, setMaterial] = useState<iMaterialList[]>([]);

    const count = 20;
    let max_count: number = 999;

    const [page, setPage] = useState(-count);
    const loader = useRef(null);

    const handleObserver = useCallback((entries: any) => {
        const target = entries[0];
        if (target.isIntersecting) {
            setPage((prevState) => {
                if (prevState + count > max_count) {
                    return prevState;
                }
                return prevState + count;
            });
        }
    }, []);

    async function getMaxMaterialCount(): Promise<number> {
        let url = new URL(
            basic.server + v_member.member + v_member.material_count
        );
        let params = {
            companyNum: member.companyNum,
            companyType: member.companyType,
            classVersion: member.classVersion,
        };
        url.search = new URLSearchParams(params).toString();

        const response = await axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        });
        const data = await response.data;
        const count: number = data.count.count;
        return count;
    }

    useEffect(() => {
        const init = async () => {
            max_count = await getMaxMaterialCount();
        };
        init();
    }, []);

    useEffect(() => {
        const option = {
            root: null,
            rootMargin: '20px',
            threshold: 0,
        };
        const observer = new IntersectionObserver(handleObserver, option);
        if (loader.current) observer.observe(loader.current!);
    }, [handleObserver]);

    const getMaterialList = (position: number, count: number) => {
        console.log('in getMaterialList position', position);

        let url = new URL(
            basic.server + v_member.member + v_member.member_material_list
        );
        let params = {
            position: position.toString(),
            count: count.toString(),
            companyNum: member.companyNum,
            classVersion: member.classVersion,
        };
        url.search = new URLSearchParams(params).toString();
        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data: any) => {
                if (data.code == Values.SUCCESS_CODE) {
                    console.log(data.materials);
                    setMaterial((prevState) =>
                        prevState.concat(
                            data.materials.map((item: any) =>
                                Object.assign(item, { quantity: 0 })
                            )
                        )
                    );
                }
            });
    };

    useEffect(() => {
        if (page >= 0) {
            getMaterialList(page, count);
        }
    }, [page]);

    const goMaterialLoanPage = () => {
        history.push('/materialLoanList');
    };

    return (
        <div className="content">
            <div
                style={{
                    textAlign: 'center',
                    marginLeft: 'auto',
                    paddingBottom: '1vh',
                }}
            ></div>
            <Box>
                <List className={classes.list}>
                    {material.length != 0 ? (
                        material.map((item: any, index: number) => {
                            return (
                                <ListItem className={classes.materialItem}>
                                    <MaterialItem
                                        key={index}
                                        {...item}
                                        quantity={item.quantity}
                                    ></MaterialItem>
                                </ListItem>
                            );
                        })
                    ) : (
                        <div className={classes.empty}>
                            <div>
                                <img src="/images/title/product2.webp" />
                                <Typography variant="h1">
                                    재료가 없습니다.
                                </Typography>
                            </div>
                        </div>
                    )}
                    <div ref={loader}></div>
                </List>
            </Box>
            <div className={classes.fixedButtonWrapper}>
                <Button
                    className={classes.materialLoanButton}
                    onClick={() => goMaterialLoanPage()}
                >
                    <Typography
                        variant="h3"
                        className={classes.materialLoanButtonText}
                    >
                        판매한 재료 보기
                    </Typography>
                </Button>
            </div>
        </div>
    );
};

const MaterialItem: React.FC<any> = (props) => {
    const classes = useStyles();

    return (
        <Grid container justify={'center'} alignContent="center" translate="no">
            <Grid xs={3} className={classes.materialImage}>
                <img
                    src={
                        basic.server +
                        '/displayImage?fileName=' +
                        props.materialImage
                    }
                />
            </Grid>
            <Grid xs={5} style={{ margin: 'auto' }}>
                <Grid
                    container
                    className={classes.materialDesc}
                    direction="column"
                >
                    <Grid id="materialName">{props.materialName}</Grid>
                    <Grid id="materialSubName">
                        {props.materialSubName} {props.materialCode}
                    </Grid>
                </Grid>
            </Grid>
            <Grid xs={4} style={{ margin: 'auto' }}>
                <Grid
                    container
                    className={classes.materialButtonSection}
                    direction="column"
                    alignItems="center"
                >
                    <Grid container alignItems="center">
                        <Grid xs={4} id="count">
                            <NumberFormat
                                value={props.materialCount}
                                displayType={'text'}
                                thousandSeparator={true}
                                suffix={'개'}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default MaterialList;
